import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import { AnalysisHeader, Message, MsgFile } from '../Input';
import { useResults } from '../context/ResultsProvider';
import { assertSpam, assertLegit, useAssertion } from '../context/AssertionProvider';
import useApiResult from '../useApiResult';
import useScopes from '../useScopes';
import { reporterBase, customerId } from '../identity';
import Button from '@proofpoint/fuse/components/Button';

export const AssertButton = ({setFlash}) => {
  const [results] = useResults();
  const [assertResults, dispatch] = useAssertion();
  const {user} = useAuth0();
  const [at_scopes, error, done] = useScopes();
  const requests = assertResults.requests;
  let scopes = [];

  useApiResult(requests, dispatch);
  
  useEffect(() => {
    if (assertResults.error !== null) {
      let error_message
      try {
        const jr = JSON.parse(assertResults.error);
        error_message  = (Object.prototype.hasOwnProperty.call(jr, 'message')) ? jr.message : JSON.stringify(jr);
      } catch (e) {
        error_message = "Oops! Something went wrong";
        console.error(e);
      }
      setFlash({severity:"error", message:error_message, open:true});
      return;
    }
    if (assertResults.done) {
      setFlash({severity:"success", message:"Feedback successfully submitted to Cloudmark Network Feedback System", open:true});
    }
  }, [assertResults.done, assertResults.error, setFlash])
  
  // Build a local scope string safely without mutating the user object
  let scopeString = typeof user.scope === 'string' ? user.scope : '';
  if (Object.prototype.hasOwnProperty.call(user, "https://cat.cloudmark.com/roles")) {
    scopeString += " " + user["https://cat.cloudmark.com/roles"].join(" ");
  }
  if (at_scopes) {
    scopeString += " " + at_scopes;
  }
  scopeString = scopeString.trim();
  if (scopeString.length === 0) return null;
  scopeString.split(' ').forEach(scope => { if (scope && !scopes.includes(scope)) scopes.push(scope); });

  scopes = scopes.map(scope => scope.split(':'));

  const hasScope = (rw, type, action) => {
    //Example scope: ['write', 'cat', 'message', 'block', '3']
    for (const scope of scopes) {
      if (scope.length != 5) continue; //some other scope
      if (scope[0] === rw && scope[2] === type && scope[3] === action) return scope[4];
    }
    return 0;
  }

  const setSpam = (limit) => {
    doAssert(assertSpam, limit);
  }

  const setLegit = (limit) => {
    doAssert(assertLegit, limit);
  }

  const doAssert = (fn, limit) => {
    let ids = [];
    for (let i=0; i < limit; i++) {
      let id = {}
      id.customerId = customerId(user);
      id.reporter = reporterBase(user) + i.toString();
      ids.push(id);
    }
    dispatch(fn(results, ids));
  };


  if (!(results.input instanceof Message || results.input instanceof MsgFile || results.input instanceof AnalysisHeader)) {
    return null;
  }
  
  if (results.loading || assertResults.loading) {
    return (<Button loading={true} style={{marginLeft:'20px'}}>Loading</Button>);
  }

  if (results.error !== null) {
    return null;
  }
  
  

  if (results.done && results.data.algorithmResults !== undefined) {
    const type = (results.input instanceof Message || results.input instanceof MsgFile)? "message" : "header";
    const action = (results.data.algorithmResults.filter(e => e.activeThreat).length > 0)? "unblock" : "block";
    const limit = hasScope('write', type, action);
    if (limit === 0) return null;
    const type_label = (type === "message")? "Message" : "Analysis String";
    const action_label = (action === "unblock")? "Unblock" : "Block";
    const icon = (action === "block")? <ThumbDownAltIcon /> : <ThumbUpAltIcon />;
    const assert = () => (action === "block")? setSpam(limit) : setLegit(limit);
    const buttonLabel = `${action_label} ${type_label}`;
    if (assertResults.done) {
      return <Button disabled={true} icon={icon} style={{marginLeft:'20px'}}>{buttonLabel}</Button>
    }
    return(
      <Button onClick={assert} aria-label={buttonLabel} icon={icon} style={{marginLeft:'20px'}}>{buttonLabel}</Button>
    );
  }
  return null;
}
